import { MathUtils, Vector3 } from "three";

export const lerp = (
  x: number | Vector3,
  y: number | Vector3,
  t: number
): number | Vector3 | undefined => {
  if (typeof x === "number" && typeof y === "number") {
    return MathUtils.lerp(x, y, t);
  } else if (x instanceof Vector3 && y instanceof Vector3) {
    return new Vector3(
      MathUtils.lerp(x.x, y.x, t),
      MathUtils.lerp(x.y, y.y, t),
      MathUtils.lerp(x.z, y.z, t)
    );
  }
};
